// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__jX7ii","main":"Layout_main__fTBqr"};